import { Switch, useMatches } from "@mantine/core";
import { useContext } from "react";
import { useCurrentUserQuery } from "../../hooks/useCurrentUserQuery";
import { ShowStaffViewContext } from "../App/ShowStaffViewContext";

interface StaffViewToggleProps {
  toggleShowStaffView: () => void;
}

function StaffViewToggle({ toggleShowStaffView }: StaffViewToggleProps) {
  const { currentUser } = useCurrentUserQuery();
  const isStaff = currentUser?.is_staff ?? false;
  const showStaffView = useContext<boolean | undefined>(ShowStaffViewContext);

  function handleClickStaffViewToggle(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
  }

  const responsiveShowLabel = useMatches({
    base: false,
    md: true
  });

  const responsiveSize = useMatches({
    base: "xs",
    md: "sm"
  });

  if (!isStaff || typeof showStaffView === "undefined") {
    return null;
  }

  const text = showStaffView ? "node.energy-Ansicht" : "Kundenansicht";

  return (
    <Switch
      aria-label="Toggle zwischen Kundenansicht und node.energy-Ansicht"
      checked={showStaffView}
      className="StaffViewToggle"
      label={responsiveShowLabel ? text : undefined}
      labelPosition="left"
      size={responsiveSize}
      onChange={toggleShowStaffView}
      onClick={handleClickStaffViewToggle}
    />
  );
}

export { StaffViewToggle, StaffViewToggleProps };
